import type { SystemStyleObject } from "@chakra-ui/theme-tools";
import colors from "../../design-tokens/01.colors/colors";

export const scrollbarStyles: SystemStyleObject = {
    "::-webkit-scrollbar": { width: "2px", height: "2px" },
    // Direct design token value used here because chakra css vars are not resolved here and broke this style
    "::-webkit-scrollbar-thumb": { background: colors.gray[800] },
    "::-webkit-scrollbar-track": { background: colors.gray[200] },
    scrollbarColor: colors.gray[200],
};
